<template>
  <div class="app-activate-auto-top-up">
    <div class="text"><slot name="txtBeforeAutoTopUp"></slot></div>
      <b-form
        class="change-auto-top-up-form"
        :id="'form' + _uid"
        :novalidate="true">
          <b-form-radio-group  required
                               class="top-up-group"
                               v-model="splittedTopUp"
          >
            <auto-top-up
              :top-up="topUp_"
              :trigger.sync="topUp_.trigger"
              :amount.sync="topUp_.amount"
              :monthly-value="monthlyValue"
              :inside-activation="false"
            >
              <template #txtHeaderMonthly><slot name="txtHeaderMonthlyAutoTopUp"></slot></template>
              <template #txtHeaderMonthlyInside><slot name="txtHeaderMonthlyInsideAutoTopUp"></slot></template>
              <template #lblMonthly><slot name="lblMonthlyAutoTopUp"></slot></template>
              <template #txtDescByLimit><slot name="txtDescByLimitAutoTopUp"></slot></template>
              <template #txtHeaderByLimitInside><slot name="txtHeaderByLimitInsideAutoTopUp"></slot></template>
              <template #lblMonthlyAmount><slot name="lblMonthlyAmountAutoTopUp"></slot></template>
              <template #txtHeaderByLimit><slot name="txtHeaderByLimitAutoTopUp"></slot></template>
              <template #lblByLimitFirst><slot name="lblByLimitAutoTopUpFirst"></slot></template>
              <template #lblByLimitSecond><slot name="lblByLimitAutoTopUpSecond"></slot></template>
            </auto-top-up>
          </b-form-radio-group>
      </b-form>
      <b-overlay class="btn-next-overlay" :show="loading" spinner-small>
        <b-button v-on:click="activate" class="btn-next" type="button" variant="primary" :disabled="$v.$invalid || loading">
          <slot name="btnNext">aktivieren</slot>
        </b-button>
      </b-overlay>
    </div>
</template>
<script>
import { validationMixin } from 'vuelidate'
import AutoTopUp from '../AutoTopUp.vue'
import processSteps from '../../../../../mixins/processSteps'
import isValid from '../../../../../mixins/isValid'
import { required, numeric } from 'vuelidate/lib/validators'
import { mapActions, mapMutations } from 'vuex'
import { stepName as nextProcessStep } from '../../../../generic/Success2.vue'
import syncProperty from '@/mixins/syncProperty'
export const stepName = 'activate'
export default {
  name: 'ActivateAutoTopUp',
  data () {
    return {
      loading: false
    }
  },
  computed: {
    splittedTopUp: {
      get: function () {
        if (this.topUp_.type === 'monthly') {
          return {
            type: this.topUp_.type,
            trigger: this.topUp_.trigger
          }
        }
        return {
          type: this.topUp_.type
        }
      },
      set: function (value) {
        this.topUp_.type = value.type
        if (value.type === 'monthly') {
          this.topUp_.trigger = value.trigger
        }
      }
    }
  },
  mixins: [
    syncProperty('topUp', 'topUp_'),
    validationMixin,
    isValid,
    processSteps(stepName, stepName, nextProcessStep)
  ],
  validations () {
    return {
      topUp: {
        amount: {
          required,
          numeric
        },
        trigger: {
          required,
          numeric
        },
        type: {
          required
        }
      }
    }
  },
  components: { AutoTopUp },
  methods: {
    activate () {
      this.loading = true
      this.changeAutoTopUp({ topUpData: this.topUp_, nextStep: this.nextStep }).then(() => {
        this.loading = false
      }, () => {
        this.loading = false
      })
    },
    ...mapActions('topUp', [
      'changeAutoTopUp'
    ]),
    ...mapMutations('topUp', [
      'setActivationView'
    ])
  },
  props:
    [
      'monthlyValue'
    ]
}
</script>
